<div>
    <app-layer-group-title
        [groupInfo]="groupInfo"
        [showShowAllButton]="
            !!(searchKeyExists$ | async) && numOfVisibleLayers !== (layers$ | async)!.length
        "
        [showHideAllButton]="!!numOfVisibleLayers"
        [showToggleAllButton]="true"
        [listOpen]="groupInfo.listOpen || false"
        (selectLayerGroup)="layerGroupSelected($event)"
        (showAllLayers)="showAllLayers()"
        (hideAllLayers)="hideAllLayers()"
        (toggleLayerGroup)="toggleLayerGroup()"
    ></app-layer-group-title>
    <div *ngIf="groupInfo.listOpen || false" class="layer-list">
        <ng-container *ngFor="let layer of layers$ | async">
            <app-layer-group-item
                [layer]="layer"
                (selectLayer)="layerSelected($event)"
            ></app-layer-group-item>
        </ng-container>
    </div>
</div>
